import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "عبدالله الشمري",
    initials: "ع",
    text: "ناس محترمين وأمناء جدًا، ومن أول ما شرحت المشكلة تم تشخيصها بشكل صحيح وإصلاحها باحترافية. أنصح بهم بقوة لأعطال المكيفات.",
    tag: "مكيف سيارة",
  },
  {
    name: "فهد العتيبي",
    initials: "ف",
    text: "الأخ أسعد فني متمكن، تتبع عطل المكيف باحترافية ووجد الخلل خلال وقت قصير وتم الإصلاح بشكل ممتاز.",
    tag: "فحص وتشخيص",
  },
  {
    name: "سلطان الدوسري",
    initials: "س",
    text: "تعامل راقٍ جدًا، واهتمام بالتفاصيل، ومصداقية في الشغل. من أفضل الأماكن اللي تعاملت معها في صيانة المكيف.",
    tag: "ترهيم مكيف",
  },
  {
    name: "ناصر القحطاني",
    initials: "ن",
    text: "خبرة واضحة جدًا في أعطال التكييف، وتشخيص دقيق من أول مرة. خدمة ممتازة وسرعة في الإنجاز.",
    tag: "تعبئة فريون",
  },
];

const Stars = ({ filled = 5 }) => (
  <div className="flex items-center gap-0.5">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${
          i < filled ? "text-amber-400 fill-amber-400" : "text-slate-600"
        }`}
      />
    ))}
  </div>
);

export const Testimonials = () => {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative py-20 lg:py-28 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          {/* Rating summary */}
          <div className="lg:col-span-4 reveal lg:sticky lg:top-24">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-cyan-400 font-semibold mb-4">
              <span className="w-8 h-px bg-cyan-400" />
              آراء العملاء
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
              رضا موثّق من عملاء حقيقيين
            </h2>
            <p className="mt-5 text-slate-400 leading-relaxed">
              ما نقوله عن نفسنا مش هو المهم — المهم شو بيقولوه العملاء.
            </p>

            <div className="mt-8 rounded-2xl border border-slate-800 bg-slate-900/60 p-6">
              <div className="flex items-baseline gap-2">
                <span className="text-6xl font-extrabold text-white tabular-nums">
                  4.7
                </span>
                <span className="text-slate-400">/ 5</span>
              </div>
              <div className="mt-3">
                <Stars filled={5} />
              </div>
              <div className="mt-3 text-sm text-slate-400">
                بناءً على{" "}
                <span className="text-white font-semibold tabular-nums">
                  +474
                </span>{" "}
                مراجعة على جوجل
              </div>
              <div className="mt-5 grid grid-cols-5 gap-1.5 text-[11px] text-slate-400">
                {[
                  { label: "5", pct: 78 },
                  { label: "4", pct: 14 },
                  { label: "3", pct: 5 },
                  { label: "2", pct: 2 },
                  { label: "1", pct: 1 },
                ].map((b) => (
                  <div key={b.label} className="flex flex-col gap-1 items-center">
                    <div className="w-full h-20 bg-slate-950 rounded-md relative overflow-hidden border border-slate-800">
                      <div
                        className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-cyan-500 to-cyan-400"
                        style={{ height: `${b.pct}%` }}
                      />
                    </div>
                    <span>{b.label}★</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Reviews grid */}
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5 lg:gap-6">
            {reviews.map((r, i) => (
              <figure
                key={i}
                data-testid={`review-card-${i}`}
                className="reveal relative rounded-2xl p-6 lg:p-7 border border-slate-800 bg-slate-900/60 hover:border-cyan-500/30 transition-all"
              >
                <Quote className="absolute top-5 left-5 w-8 h-8 text-cyan-500/20" />
                <Stars filled={5} />
                <blockquote className="mt-4 text-slate-200 text-[15px] lg:text-base leading-relaxed">
                  {r.text}
                </blockquote>
                <figcaption className="mt-5 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500/30 to-cyan-700/30 border border-cyan-500/30 flex items-center justify-center text-cyan-300 font-bold">
                      {r.initials}
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-white">
                        {r.name}
                      </div>
                      <div className="text-xs text-slate-500">عميل موثّق</div>
                    </div>
                  </div>
                  <span className="text-[11px] font-semibold px-2.5 py-1 rounded-full bg-cyan-500/10 text-cyan-300 border border-cyan-500/20">
                    {r.tag}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
